export const GET_REVENUE_CENTERS_REQUESTED =
  'GET_REVENUE_CENTERS_REQUESTED'
export const GET_REVENUE_CENTERS_SUCCEEDED =
  'GET_REVENUE_CENTERS_SUCCEEDED'
export const GET_REVENUE_CENTERS_FAILED = 'GET_REVENUE_CENTERS_FAILED'

export const CREATE_REVENUE_CENTERS_REQUESTED =
  'CREATE_REVENUE_CENTERS_REQUESTED'
export const CREATE_REVENUE_CENTERS_SUCCEEDED =
  'CREATE_REVENUE_CENTERS_SUCCEEDED'
export const CREATE_REVENUE_CENTERS_FAILED =
  'CREATE_REVENUE_CENTERS_FAILED'

export const UPDATE_REVENUE_CENTERS_REQUESTED =
  'UPDATE_REVENUE_CENTERS_REQUESTED'
export const UPDATE_REVENUE_CENTERS_SUCCEEDED =
  'UPDATE_REVENUE_CENTERS_SUCCEEDED'
export const UPDATE_REVENUE_CENTERS_FAILED =
  'UPDATE_REVENUE_CENTERS_FAILED'

export const EDIT_REVENUE_CENTER_REQUESTED =
  'EDIT_REVENUE_CENTER_REQUESTED'
export const EDIT_REVENUE_CENTER_SUCCEEDED =
  'EDIT_REVENUE_CENTER_SUCCEEDED'
export const EDIT_REVENUE_CENTER_FAILED = 'EDIT_REVENUE_CENTER_FAILED'
export const CLEAR_EDIT_REVENUE_CENTER = 'CLEAR_EDIT_REVENUE_CENTER'

export const SEARCH_GLOBAL_REVENUE_CENTERS =
  'SEARCH_GLOBAL_REVENUE_CENTERS'
export const FILTER_REVENUE_CENTERS_BY_SERVICE_TYPES =
  'FILTER_REVENUE_CENTERS_BY_SERVICE_TYPES'

// Service Types //

export const GET_SERVICE_TYPE_REQUESTED = 'GET_SERVICE_TYPE_REQUESTED'
export const GET_SERVICE_TYPE_SUCCEEDED = 'GET_SERVICE_TYPE_SUCCEEDED'
export const GET_SERVICE_TYPE_FAILED = 'GET_SERVICE_TYPE_FAILED'

export const ADD_SERVICE_TYPE_REQUESTED = 'ADD_SERVICE_TYPE_REQUESTED'
export const ADD_SERVICE_TYPE_SUCCEEDED = 'ADD_SERVICE_TYPE_SUCCEEDED'
export const ADD_SERVICE_TYPE_FAILED = 'ADD_SERVICE_TYPE_FAILED'

export const UPDATE_SERVICE_TYPE_REQUESTED =
  'UPDATE_SERVICE_TYPE_REQUESTED'
export const UPDATE_SERVICE_TYPE_SUCCEEDED =
  'UPDATE_SERVICE_TYPE_SUCCEEDED'
export const UPDATE_SERVICE_TYPE_FAILED = 'UPDATE_SERVICE_TYPE_FAILED'

export const CLEAR_SERVICE_TYPES_SUCCEEDED =
  'CLEAR_SERVICE_TYPES_SUCCEEDED'

export const SET_SERVICE_TYPES_WITH_ITEMS =
  'SET_SERVICE_TYPES_WITH_ITEMS'
export const CLEAR_SERVICE_TYPES_WITH_ITEMS =
  'CLEAR_SERVICE_TYPES_WITH_ITEMS'

// LOCATION SETTINGS //

export const GET_LOCATION_SETTINGS_REQUESTED =
  'GET_LOCATION_SETTINGS_REQUESTED'
export const GET_LOCATION_SETTINGS_SUCCEEDED =
  'GET_LOCATION_SETTINGS_SUCCEEDED'
export const GET_LOCATION_SETTINGS_FAILED =
  'GET_LOCATION_SETTINGS_FAILED'

export const ADD_LOCATION_SETTINGS_REQUESTED =
  'ADD_LOCATION_SETTINGS_REQUESTED'
export const ADD_LOCATION_SETTINGS_SUCCEEDED =
  'ADD_LOCATION_SETTINGS_SUCCEEDED'
export const ADD_LOCATION_SETTINGS_FAILED =
  'ADD_LOCATION_SETTINGS_FAILED'

export const UPDATE_LOCATION_SETTINGS_REQUESTED =
  'UPDATE_LOCATION_SETTINGS_REQUESTED'
export const UPDATE_LOCATION_SETTINGS_SUCCEEDED =
  'UPDATE_LOCATION_SETTINGS_SUCCEEDED'
export const UPDATE_LOCATION_SETTINGS_FAILED =
  'UPDATE_LOCATION_SETTINGS_FAILED'

export const CLEAR_LOCATION_SETTINGS_SUCCEEDED =
  'CLEAR_LOCATION_SETTINGS_SUCCEEDED'

// MENU SETTINGS //

export const GET_MENU_SETTINGS_REQUESTED =
  'GET_MENU_SETTINGS_REQUESTED'
export const GET_MENU_SETTINGS_SUCCEEDED =
  'GET_MENU_SETTINGS_SUCCEEDED'
export const GET_MENU_SETTINGS_FAILED = 'GET_MENU_SETTINGS_FAILED'

export const ADD_MENU_SETTINGS_REQUESTED =
  'ADD_MENU_SETTINGS_REQUESTED'
export const ADD_MENU_SETTINGS_SUCCEEDED =
  'ADD_MENU_SETTINGS_SUCCEEDED'
export const ADD_MENU_SETTINGS_FAILED = 'ADD_MENU_SETTINGS_FAILED'

export const UPDATE_MENU_SETTINGS_REQUESTED =
  'UPDATE_MENU_SETTINGS_REQUESTED'
export const UPDATE_MENU_SETTINGS_SUCCEEDED =
  'UPDATE_MENU_SETTINGS_SUCCEEDED'
export const UPDATE_MENU_SETTINGS_FAILED =
  'UPDATE_MENU_SETTINGS_FAILED'

export const CLEAR_MENU_SETTINGS_SUCCEEDED =
  'CLEAR_MENU_SETTINGS_SUCCEEDED'

// AVAILABILITY

export const GET_AVAILABILITY_REQUESTED = 'GET_AVAILABILITY_REQUESTED'
export const GET_AVAILABILITY_SUCCEEDED = 'GET_AVAILABILITY_SUCCEEDED'
export const GET_AVAILABILITY_FAILED = 'GET_AVAILABILITY_FAILED'
